import React, { useState } from 'react';
import { Platform } from 'react-native';
import { Checkbox, DataTable, useTheme } from 'react-native-paper';
import * as Device from 'expo-device';
import PropTypes from 'prop-types';

// Determine how many crops to display on each page of the table
const itemsPerPage = Platform.OS === 'web' && !Device.brand ? 7 : 5;

function CropDataTable({
  arrayHelpers,
  checked,
  crops,
  language,
  pageContent,
  toggleChecked,
  values,
}) {
  const [page, setPage] = useState(0);
  const from = page * itemsPerPage;
  const { colors } = useTheme();

  // Crops to display on current pae of the table
  const pageCrops = crops.slice(
    page * itemsPerPage,
    page * itemsPerPage + itemsPerPage
  );
  const of = language === 'en' ? 'of' : language === 'es' ? 'de' : 'TRANSLATE';

  const onPress = (crop, cropIndex) => {
    // Toggle the check status (T/F) for a crop checkbox
    let newChecked = checked.slice();
    newChecked[from + cropIndex] = !checked[from + cropIndex] ? true : false;
    toggleChecked(newChecked);

    if (!checked[from + cropIndex]) {
      // Add crop to array if it is now checked
      arrayHelpers.push({ name: crop.key });
    } else {
      // Remove crop from array if it is now unchecked
      const idx = values.crops.indexOf(
        values.crops.find((obj) => obj.name === crop.key)
      );
      arrayHelpers.remove(idx);
    }
  };

  return (
    <DataTable>
      <DataTable.Header>
        <DataTable.Title>{pageContent.labels[0]}</DataTable.Title>
        <DataTable.Title numeric>{pageContent.labels[1]}</DataTable.Title>
      </DataTable.Header>

      {pageCrops.map((crop, index) => (
        <DataTable.Row key={`dtr-${crop.name}`}>
          <DataTable.Cell>{crop.name}</DataTable.Cell>
          <DataTable.Cell numeric>
            <Checkbox
              status={
                values.crops.find((obj) => obj.name === crop.key) !== undefined
                  ? 'checked'
                  : 'unchecked'
              }
              onPress={() => onPress(crop, index)}
              color={colors.accent}
            />
          </DataTable.Cell>
        </DataTable.Row>
      ))}

      <DataTable.Pagination
        page={page}
        numberOfPages={Math.ceil(crops.length / itemsPerPage)}
        onPageChange={(page) => setPage(page)}
        label={`${from + 1}-${from + pageCrops.length} ${of} ${crops.length}`}
      />
    </DataTable>
  );
}

CropDataTable.propTypes = {
  arrayHelpers: PropTypes.object,
  checked: PropTypes.array,
  crops: PropTypes.array,
  language: PropTypes.string,
  pageContent: PropTypes.object,
  toggleChecked: PropTypes.func,
  values: PropTypes.object,
};

export default CropDataTable;
